import moment from 'moment';

import AsyncStorage from '../../async-storage';

const purgeClientLogs = async () => {
  // Delete all clientLog records older than 15 days in the past
  const allKeys = await AsyncStorage.getAllKeys();

  // Go through each key and if it matches our key format and contains the date...burn it
  const keysToPurge = allKeys.filter((key) => {
    // console.devLog.info('Key:', key);
    if (key.includes('@Nerdfitness:clientLog')) {
      return true;
      const dashIndex = key.indexOf('-');
      const date = key.substring(dashIndex + 1);

      // console.devLog.info('Date:', date);
      // Purging all logs for now
      if (moment(date).isBefore(moment().subtract(10, 'days'))) {
        return true;
      }
    }
    return false;
  });

  await AsyncStorage.multiRemove(keysToPurge);
};

export default purgeClientLogs;
